import type { RiskFilter } from '../types';

interface Props {
  risk: RiskFilter;
  search: string;
  total: number;
  visible: number;
  alertOnly?: boolean;
  onRiskChange: (r: RiskFilter) => void;
  onSearchChange: (s: string) => void;
  onAlertOnlyChange?: (enabled: boolean) => void;
}

const RISK_OPTIONS: { value: RiskFilter; label: string }[] = [
  { value: 'all', label: 'Vše' },
  { value: 'high', label: 'Vysoké' },
  { value: 'medium', label: 'Střední' },
  { value: 'low', label: 'Nízké' },
  { value: 'unknown', label: 'Neposouzeno' },
];

export function FilterBar({ risk, search, total, visible, alertOnly = false, onRiskChange, onSearchChange, onAlertOnlyChange }: Props) {
  return (
    <div className="filter-bar">
      <div className="filter-bar__risk">
        {RISK_OPTIONS.map((opt) => (
          <button
            key={opt.value}
            className={`risk-btn risk-btn--${opt.value} ${risk === opt.value ? 'risk-btn--active' : ''}`}
            onClick={() => onRiskChange(opt.value)}
            aria-pressed={risk === opt.value}
          >
            {opt.label}
          </button>
        ))}
      </div>

      {onAlertOnlyChange && (
        <label className="filter-bar__alert-toggle">
          <input
            type="checkbox"
            checked={alertOnly}
            onChange={(e) => onAlertOnlyChange(e.target.checked)}
          />
          <span>Pouze s upozorněním</span>
        </label>
      )}

      <div className="filter-bar__search">
        <input
          type="search"
          placeholder="Hledat název nebo shrnutí…"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          aria-label="Hledat analýzy"
          className="search-input"
        />
      </div>

      <div className="filter-bar__count" aria-live="polite">
        {visible < total ? `${visible} z ${total}` : total} {total === 1 ? 'položka' : 'položek'}
      </div>
    </div>
  );
}
